import { ResourceType } from "@/services/cloudchipr.api";
import { ResourceDataType } from "@/store/live-usage-mgmt/utils/types/types";

export const getFirstResourceTypeFromResources = (
  resources: ResourceDataType[] | undefined,
): ResourceType | undefined => {
  return resources?.[0]?.resource_type;
};
